import React from 'react'
import Fade from 'react-reveal/Fade';

import placeholder from '../../../assets/png/placeholder.png'
import './SingleBlog.css'
import { theme } from '../../../theme/designSystem';

function SingleBlog({ title, desc, date, image, url, id }) {
    return (
        <Fade bottom>
            <a className="singleBlog" key={id} href={url} target="_blank" rel="noreferrer" style={{ backgroundColor: theme.secondary, boxShadow: theme.shadows.md, borderRadius: theme.shape.borderRadius }}>
                <div className="singleBlog--image" style={{ backgroundColor: theme.tertiary }}>
                    <img src={image ? image : placeholder} alt={title} />
                </div>
                <div className="singleBlog--body">
                    <p style={{ color: theme.accent }}>{date}</p>
                    <h3 style={{ color: theme.primary }}>{title}</h3>
                    <h6 style={{ color: theme.textSecondary }}>{desc}</h6>
                </div>
            </a>
        </Fade>
    )
}

export default SingleBlog
